<template>
    <div class="item">
        <div class="head">
            <div class="name">
                <div v-if="orderItem.quantity !== 1" class="quantity">{{ orderItem.quantity }}x</div>
                {{ optionName }}<ItemIcons v-if="orderItem.articleId" :articleId="orderItem.articleId" />
            </div>
            <div v-if="displayPrice" class="price">{{ price }}</div>
        </div>

        <div v-if="orderItem.options.length" class="subs">
            <OptionGroup
                v-for="optionGroup in orderItem.options"
                :key="optionGroup.id"
                :optionGroup="optionGroup"
                :isParentItemCancelled="isParentItemCancelled"
                :displayPrice="displayPrice"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { IOrderItem } from "@/data/model/Order";
    import { getNameInLocationLanguage } from "@/shared/helpers/ItemNameHelper";
    import { toMoney } from "@/shared/utils/format";
    import { computed } from "vue";

    import ItemIcons from "@/components/order/ItemIcons.vue";
    import OptionGroup from "@/operator/components/order/OptionGroup.vue";

    const props = defineProps<{
        orderItem: IOrderItem;
        isParentItemCancelled: boolean;
        displayPrice: boolean;
    }>();

    const optionName = computed(
        () => getNameInLocationLanguage(props.orderItem, true)
    );

    const price = computed((): string => {
        if (props.orderItem.unitPrice === 0) return "";

        return toMoney(
            props.orderItem.isCancelled ? props.orderItem.originalTotalAmount : props.orderItem.currentTotalAmount,
            true
        );
    });
</script>
